
import React from 'react';
import { FacilityOrderPatientNewFlowUSIntakeInsuranceInfoModalTemplate } from 'themes/application/facility-order-new-flow-us-intake/components';
import { observer } from 'mobx-react';
import { setCurrentView } from 'core/utils';
import { FacilityOrderPatientNewFlowUSIntakeInsuranceInfoModalStore } from 'application/facility-order-new-flow-us-intake/stores';

@setCurrentView((rootStore, componentProps) => new FacilityOrderPatientNewFlowUSIntakeInsuranceInfoModalStore(rootStore, componentProps), 'FacilityOrderPatientNewFlowUSIntakeInsuranceInfoModalStore')
@observer
class FacilityOrderPatientNewFlowUSIntakeInsuranceInfoModal extends React.Component {
    render() {
        return <FacilityOrderPatientNewFlowUSIntakeInsuranceInfoModalTemplate {...this.props} />
    }
}

export default FacilityOrderPatientNewFlowUSIntakeInsuranceInfoModal;
